// extracted by mini-css-extract-plugin
export default {"card":"T3-z"};